/**
 * This enum collects the endpoins the app may call when doing requests
 * to the backend.
 */
enum ApiRoutes {
    // Account
    ACCOUNT_UPDATE_SETTINGS = '/v1/account/update-settings',

    // System (general)
    SYSTEM_GET_SETTINGS = '/v1/system-settings'
}

export default ApiRoutes;